import {
  compareCategoryGroups,
  getProductGroupCategory,
  getProductUnitDetails,
  PROMOTIONS_CATEGORY_ID,
  PROMOTIONS_CATEGORY_NAME
} from 'modules/products'

import {
  CartItem,
  CategoryAccTypes,
  CategoryAccTypesWithProductCount
} from '../../types'

export const getCategoriesWithProductCount = (
  categories: CategoryAccTypes[]
): CategoryAccTypesWithProductCount[] => {
  return categories.map(category => ({
    ...category,
    categoryItemsCount: category.items.length
  }))
}

export const sortCartItemsByCategory = (items: CartItem[]) => {
  if (!items) return []

  const result = items.reduce((acc: CategoryAccTypes[], item: CartItem) => {
    const category = item.promotionId
      ? { id: PROMOTIONS_CATEGORY_ID, name: PROMOTIONS_CATEGORY_NAME }
      : getProductGroupCategory(item.product)

    const existingCategory = acc.find(
      (i: CategoryAccTypes) => i.categoryName === category.name
    )

    if (existingCategory) {
      existingCategory.items.push(item)
    } else {
      const payload: CategoryAccTypes = {
        categoryId: category.id,
        categoryName: category.name,
        items: [item]
      }

      acc.push(payload)
    }

    return acc
  }, [])

  return result.sort(compareCategoryGroups)
}

export const getProductPricesFromCartItem = (item: CartItem) => {
  const defaultPrice: string | null = item?.valueGross?.formatted || '---'
  const unitDetails = getProductUnitDetails(item.product)

  const promoPrice = item?.specialOfferValueGross?.formatted || null
  const currentPrice = promoPrice || defaultPrice

  return {
    currentPrice,
    defaultPrice,
    unitDetails
  }
}

export const IS_DISABLED_MANIPULATION_CART_PROMOTION_ITEMS = true
